/* eslint-disable @typescript-eslint/ban-ts-comment */
import { AxiosResponse } from "axios";
import { coreFeedbackUrls } from "../../url";
import { taxGuruAxios } from "../../axios";
import {
    CoreUserFeedback,
    CoreUserFeedbackRequest,
    CoreUserFeedbackResult,
    CoreUserFeedbackTypeDto,
    Filter,
} from "@mm-products/java-multima-framework";

export const listFeedbacks = (filter: Filter, signal?: AbortSignal, toastId?: string): Promise<AxiosResponse<CoreUserFeedbackResult>> => {
    return taxGuruAxios.post(coreFeedbackUrls.filter, filter, {
        signal,
        // @ts-ignore
        toastId,
    });
};

export const resolveFeedback = (
    feedbackId: string,
    feedback: CoreUserFeedbackRequest,
    signal?: AbortSignal,
    toastId?: string
): Promise<CoreUserFeedback> => {
    return taxGuruAxios
        .put(coreFeedbackUrls.resolve(encodeURIComponent(feedbackId)), feedback, {
            signal,
            // @ts-ignore
            toastId,
        })
        .then(({ data }) => data);
};

export const cancelFeedback = (feedbackId: string, signal?: AbortSignal, toastId?: string): Promise<CoreUserFeedback> => {
    return taxGuruAxios
        .post(coreFeedbackUrls.canceled(encodeURIComponent(feedbackId)), undefined, {
            signal,
            // @ts-ignore
            toastId,
        })
        .then(({ data }) => data);
};
export const createDirectFeedback = (feedback: CoreUserFeedbackRequest, signal?: AbortSignal, toastId?: string): Promise<CoreUserFeedback> => {
    return taxGuruAxios
        .post(coreFeedbackUrls.direct, feedback, {
            signal,
            // @ts-ignore
            toastId,
        })
        .then(({ data }) => data);
};

export const getFeedbackTypes = (signal?: AbortSignal, toastId?: string): Promise<Array<CoreUserFeedbackTypeDto>> => {
    return taxGuruAxios
        .get(coreFeedbackUrls.types, {
            signal,
            // @ts-ignore
            toastId,
        })
        .then(({ data }) => data);
};
